import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PlanDetail } from 'models/mdrProduct.model'
import { IviewRatesMdrFeeDataContainer } from './mdrProductSlice'
import { InsurancePartner } from 'models/insurance.model'
import { Issuer } from 'models/allIssuers.model'
import { OLIDetail } from 'models/productsV3.model'

export interface Vas {
  vasName: string
  id: number
  sfReferenceId: string
  acquirers: string[]
}

export type SelectedVasByPlan = Record<number, OLIDetail[]>

interface ProductMDRFees {
  [key: string]: {
    id: number
    value: number | string
    isInsurance?: boolean
    merchantSplit: number | string
    insurerSplit: number | string
    issuer?: number
    insurancePartner?: number
    insuranceSubPartner?: number
    isDisabled?: boolean
    disabledNonAdditionalType?: boolean
  }[]
}

interface VasServicesState {
  selectedVas: Vas[]
  currentVasProducts: PlanDetail[]
  productMdrFees: ProductMDRFees
  viewRatesMdrFeeData: null | IviewRatesMdrFeeDataContainer
  allInsurancePartners: InsurancePartner[]
  allIssuers: Issuer[]
  allSelectedVasProduct: SelectedVasByPlan
}

const initialState: VasServicesState = {
  selectedVas: [],
  currentVasProducts: [],
  productMdrFees: {},
  viewRatesMdrFeeData: null,
  allInsurancePartners: [],
  allIssuers: [],
  allSelectedVasProduct: {},
}

const vasServicesSlice = createSlice({
  name: 'vasServices',
  initialState,
  reducers: {
    setSelectedVas(state, action: PayloadAction<Vas>) {
      state.selectedVas.push(action.payload)
    },
    setSelectedVasBulk(state, action: PayloadAction<Vas[]>) {
      state.selectedVas = [...state.selectedVas, ...action.payload]
    },
    removeSelectedVas(state, action: PayloadAction<number>) {
      state.selectedVas = state.selectedVas.filter((item) => item.id !== action.payload)
    },
    resetSelectedVas(state) {
      state.selectedVas = []
    },
    setCurrentVasProducts(state, action: PayloadAction<PlanDetail[]>) {
      state.currentVasProducts = action.payload
    },
    setProductMDRFees(state, action: PayloadAction<ProductMDRFees>) {
      state.productMdrFees = action.payload
    },
    setViewRatesMdrFeeData(state, action: PayloadAction<null | IviewRatesMdrFeeDataContainer>) {
      state.viewRatesMdrFeeData = action.payload
    },
    setAllInsurancePartners(state, action: PayloadAction<InsurancePartner[]>) {
      state.allInsurancePartners = action.payload
    },
    setAllIssuers(state, action: PayloadAction<Issuer[]>) {
      state.allIssuers = action.payload
    },
    setAllSelectedVasProduct(state, action: PayloadAction<SelectedVasByPlan>) {
      state.allSelectedVasProduct = action.payload
    },
  },
})

export const {
  setSelectedVas,
  setSelectedVasBulk,
  removeSelectedVas,
  setCurrentVasProducts,
  setProductMDRFees,
  setViewRatesMdrFeeData,
  setAllInsurancePartners,
  setAllIssuers,
  setAllSelectedVasProduct,
  resetSelectedVas,
} = vasServicesSlice.actions
export default vasServicesSlice.reducer
